export { ActorModal } from './ActorModal/ActorModal';
export { DirectorModal } from './DirectorModal/DirectorModal';
export { GenreModal } from './GenreModal/GenreModal';
